import React from 'react'
import  {useEffect, useState, useRef} from 'react'
import { AddTest,GetSingleTest,Get_Categorry,Get_AgeGroup,Get_SubCategory,ImportTests,DownloadTestImportTemplate,ExportTests } from '../Services/TestServices';
import SpinnerModal from '../Spinner/SpinnerModal';
import { useApi } from '../ContextApi/ContextApi';
import { toast } from 'react-toastify';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
} from '@mui/material';
import Slide from '@mui/material/Slide';
import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded';
import '../UI/TestEntrymodal.css'
import '../UI/Common.css'

const ImportTransition = React.forwardRef(function ImportTransition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} timeout={500} />;
});

const TestRegistration = ({TestID}) =>{
    const { isTest_Submitted, setTest_SubmissionStatus } = useApi();
    const [isLoading, setIsLoading] = useState(false);
    const [TestData,setTestData] = useState({});
  const[CategorryData,SetCateGorryData] = useState([]);
  const[AgegroupData,SetAgegroupData] = useState([]);
  const[SubCategory,SetSubCategory] = useState([]);
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isImporting, setIsImporting] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const fileInputRef = useRef(null);
    const[formData,setformData] = useState({
        TestID:'',
        test_name:'',
        TestCategoryName:'',
        TestPrice :'',
        Unit:'',
        Reference_value:'',
        Comments:'',
        CATEGORY_CODE:'',
        GenderCategory:'',
        AGE_CODE:'',
        SUB_CATEGORY_CODE:''
    });
    const onchange = (e) =>{
        const {name,value} = e.target;
        setformData({
            ...formData,
            [name]:value,
        }) 
    }
    //Submit form 
    const SubmitForm = async(e) =>{
        e.preventDefault();
        setIsLoading(true)
        try{
            const response = await  AddTest(formData);
            if(response){
                toast.success("test added success fully")
                setTest_SubmissionStatus(true)
            }
        }
        catch(error){
            throw(error)
        }
        finally{
            setIsLoading(false)
        }
     
    }
    //Getting Test Data for Editng Purpose
        const RetriveTestData = async ()=>{
            if(TestID){
                setIsLoading(true)
                const LabID = sessionStorage.getItem('LabID');
                const Response = await GetSingleTest(TestID,LabID);
                setTestData(Response)
                if(Response){
                    setIsLoading(false);
                }
            }
        }

        const GetSettingData = async () => {
            try {
                const response = await Get_Categorry(sessionStorage.getItem('LabID'));
                SetCateGorryData(response);
            } catch (error) {
                console.error("Error fetching settings:", error);
            }
        };
        const GetAgeGroup = async () => {
            try {
                const response = await Get_AgeGroup(sessionStorage.getItem('LabID'));
                SetAgegroupData(response);
            } catch (error) {
                console.error("Error fetching settings:", error);
            }
          };
          const GetSubCategory = async () => {
            try {
                
                const response = await Get_SubCategory(sessionStorage.getItem('LabID'));
                SetSubCategory(response);
            } catch (error) {
                console.error("Error fetching settings:", error);
            }
          };
        useEffect(() => {
             RetriveTestData();
             GetAgeGroup();
             GetSubCategory();
        },[TestID, isTest_Submitted])

         useEffect(()=>{
            GetSettingData();
         },[isTest_Submitted])
   //mapped testData for edit 
   useEffect(() => {
    setformData({
        TestID:TestID,
        test_name: TestData.testName || '',
        TestPrice: TestData.testPrice || '',
        Unit: TestData.unit || '',
        Reference_value: TestData.normalRange || '',
        Comments: TestData.comments || '',
        CATEGORY_CODE:TestData.categorY_CODE || '',
        GenderCategory:TestData.genderCategory || '',
        AGE_CODE:TestData.agE_CODE || '',
        SUB_CATEGORY_CODE:TestData.suB_CATEGORY_CODE || ''
    });
}, [TestData]); 
//-----main Domain-------
const Gender = [
    {
      value: '0',
      label: 'All',
    },
    {
      value: 'male',
      label: 'Male',
    },
    {
      value: 'female',
      label: 'Female',
    },

  ];

//----------------------- Import / Export handlers -----------------------
const openImportModal = () => {
    setImportResult(null);
    setSelectedFile(null);
    setImportModalOpen(true);
};
const closeImportModal = () => {
    setImportModalOpen(false);
    setSelectedFile(null);
    setImportResult(null);
};
const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    setSelectedFile(file || null);
    setImportResult(null);
};
const handleDownloadTemplate = async () => {
    try {
        await DownloadTestImportTemplate();
    } catch (error) {
        toast.error("Failed to download template");
    }
};
const handleExport = async () => {
    setIsExporting(true);
    try {
        await ExportTests(sessionStorage.getItem('LabID'));
    } catch (error) {
        toast.error("Failed to export tests");
    } finally {
        setIsExporting(false);
    }
};
const handleImportSubmit = async () => {
    if (!selectedFile) {
        toast.error("Please choose an Excel file to import");
        return;
    }
    setIsImporting(true);
    try {
        const response = await ImportTests(selectedFile, sessionStorage.getItem('LabID'));
        setImportResult(response);
        if ((response?.inserted || 0) > 0 || (response?.updated || 0) > 0) {
            toast.success(`Import complete: ${response.inserted} added, ${response.updated} updated`);
            setTest_SubmissionStatus(true);
        }
        if (response?.errors?.length) {
            toast.error(`${response.errors.length} row(s) could not be imported`);
        }
        if (!response?.errors?.length && (response?.inserted || 0) === 0 && (response?.updated || 0) === 0) {
            toast.error("No rows were imported. Please check the file and try again.");
        }
    } catch (error) {
        toast.error("Failed to import file: " + (error?.response?.data || error.message));
    } finally {
        setIsImporting(false);
    }
};
//----------------------- END -----------------------

return (
        <>
     {isLoading && <SpinnerModal isLoading={isLoading} />}
        <div className='container-fluid pt-1'>
            <form onSubmit={SubmitForm}>
                <div className='row pt-1'>
                    <div className='col-sm-3 mt-2'>
                      <label className='common-Labels' >Main Category <span className='common-Asterisk'>*</span></label>
                      <select
                            className="form-select  common-Input"
                            id='CATEGORY_CODE'
                            name='CATEGORY_CODE'
                            required
                            onChange={onchange}
                            value={formData.CATEGORY_CODE}
                            >
                            <option>Select options</option>
                            {CategorryData.map((option) => (
                            <option key={option.categorY_CODE} value={option.categorY_CODE}>
                            {option.categorY_VALUE}
                            </option>
                            ))}
                        </select>
                    </div>
                    <div className='col-sm-3 mt-2'>
                    <label className='common-Labels' >Sub Category <span className='common-Asterisk'>*</span></label>
                      <select
                            className="form-select common-Input"
                            id='SUB_CATEGORY_CODE'
                            name='SUB_CATEGORY_CODE'
                            required
                            onChange={onchange}
                            value={formData.SUB_CATEGORY_CODE}
                            >
                            <option>Select options</option>
                            {SubCategory.map((option) => (
                            <option key={option.suB_CATEGORY_CODE} value={option.suB_CATEGORY_CODE}>
                            {option.suB_CATEGORY_VALUE}
                            </option>
                            ))}
                        </select>
                    </div>
                    <div className='col-sm-2 mt-2'>
                    <label className='common-Labels' >Gender<span className='common-Asterisk'>*</span></label>
                    <select
                        className="form-select  common-Input"
                        id='GenderCategory'
                        name='GenderCategory'
                        required
                        onChange={onchange}
                        value={formData.GenderCategory}
                        >
                        {Gender.map((option) => (
                            <option key={option.value} value={option.value}>
                            {option.label}
                            </option>
                        ))}
                    </select>
                    </div>
                    <div className='col-sm-1 mt-2'>
                     <label className='common-Labels'>Age<span className='common-Asterisk'>*</span></label>
                      <select className="form-select  common-Input"
                            id='AGE_CODE'
                            name='AGE_CODE'
                            required
                            onChange={onchange}
                            value={formData.AGE_CODE}
                            >
                            <option value='0'>All</option>    
                            {AgegroupData.map((option) => (
                            <option key={option.agE_CODE} value={option.agE_CODE}>
                            {option.agE_VALUE}
                            </option>
                            ))}
                        </select>
                    </div>
                    <div  className='col-sm-3 mt-2'>
                        <label className='common-Labels' >Test Name <span className='common-Asterisk'>*</span></label>
                         <input  
                            className="form-control  common-Input" 
                            id='test_name'
                            name='test_name'
                            required 
                            value={formData.test_name}
                            onChange={onchange}
                            >
                        </input>
                    </div>
                    <div  className='col-sm-3 mt-2'>
                     <label className='common-Labels'>Test Price <span className='common-Asterisk'>*</span></label>
                        <input
                            className="form-control form-control common-Input"
                            id='TestPrice'
                            name='TestPrice'
                            value={formData.TestPrice}
                            required
                            onChange={onchange} />
                    </div>
                    <div  className='col-sm-3 mt-2'>
                    <label className='common-Labels' >Reference Value <span className='common-Asterisk'>*</span></label>
                        <textarea
                            label='Reference Value'
                            className="form-control common-Textarea"
                            id='Reference_value'
                            name='Reference_value'
                            required
                            value={formData.Reference_value}
                            onChange={onchange} />
                    </div>
                      <div  className='col-sm-3 mt-2'>
                      <label className='common-Labels' >Unit <span className='common-Asterisk'>*</span></label>
                          <textarea
                              label='Unit'
                             className="form-control common-Textarea"
                              id='Unit'
                              name='Unit'
                              value={formData.Unit}
                               required
                               onChange={onchange} />
                        </div>
                        <div  className='col-sm-3 mt-2'>
                        <label className='common-Labels'>Comment </label>
                          <input
                              label='Comments'
                              className="form-control common-Input"
                              id='Comments'
                              name='Comments'
                              value={formData.Comments}
                              onChange={onchange} />
                        </div>
                         <div  className='col-sm-3 mt-2 d-flex align-items-end' style={{gap:'8px'}}>
                          <Button  variant="contained" type='submit' className="common-button">Save</Button>
                          <Button variant="contained" type="button" className="common-button" onClick={openImportModal}>
                            <CloudUploadRoundedIcon style={{fontSize:'18px', marginRight:'4px'}}/> Import
                          </Button>
                          <Button variant="contained" type="button" className="common-button" onClick={handleExport} disabled={isExporting}>
                            <FileDownloadRoundedIcon style={{fontSize:'18px', marginRight:'4px'}}/> Export
                          </Button>
                         </div>
                    </div>
            </form>
        </div>

        <Dialog
          maxWidth='sm'
          fullWidth
          PaperProps={{ style: { borderRadius:'3px' } }}
          open={importModalOpen}
          keepMounted
          onClose={closeImportModal}
          TransitionComponent={ImportTransition}
        >
          <DialogTitle className='common-FontFamily d-flex justify-content-between' sx={{fontWeight:600,backgroundColor:'#2c6bd7',color:'white'}}>
            Import Tests
            <button style={{textAlign:'end',color:'white'}} className='common-cross-button' onClick={closeImportModal}>
              <CloseRoundedIcon />
            </button>
          </DialogTitle>
          <Divider></Divider>
          <DialogContent>
            <p className='common-FontFamily' style={{marginTop:'10px', fontSize:'12px', color:'gray'}}>
              Upload an Excel file to add or update Main Category, Sub Category and Test records in bulk.
              Existing Category / Sub Category / Test records (matched by name) will be updated instead of duplicated.
            </p>
            <Divider style={{marginBottom:'15px'}}></Divider>
            <Button variant="outlined" type="button" onClick={handleDownloadTemplate} style={{marginBottom:'15px'}}>
              <FileDownloadRoundedIcon style={{fontSize:'18px', marginRight:'4px'}}/> Download Import Template
            </Button>
            <div className='d-flex align-items-center' style={{gap:'10px', marginBottom:'10px'}}>
              <input
                ref={fileInputRef}
                type="file"
                accept=".xlsx,.xls"
                style={{display:'none'}}
                onChange={handleFileChange}
              />
              <Button variant="contained" type="button" className="common-button" onClick={() => fileInputRef.current && fileInputRef.current.click()}>
                Choose File
              </Button>
              <span className='common-FontFamily'>
                {selectedFile ? (<><InsertDriveFileRoundedIcon style={{fontSize:'18px', verticalAlign:'middle'}}/> {selectedFile.name}</>) : "No file selected"}
              </span>
            </div>

            {importResult && (
              <div className='common-FontFamily' style={{marginTop:'15px', padding:'10px', border:'1px solid lightgray', borderRadius:'3px'}}>
                <div>Total rows processed: {importResult.totalRows}</div>
                <div>Added: {importResult.inserted}</div>
                <div>Updated: {importResult.updated}</div>
                <div>New Main Categories created: {importResult.categoriesCreated}</div>
                <div>New Sub Categories created: {importResult.subCategoriesCreated}</div>
                {importResult.errors && importResult.errors.length > 0 && (
                  <div style={{marginTop:'10px', color:'red'}}>
                    <div>Rows with errors:</div>
                    <ul style={{maxHeight:'150px', overflowY:'auto'}}>
                      {importResult.errors.map((err, idx) => (
                        <li key={idx}>Row {err.rowNumber}: {err.message}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={closeImportModal} variant="contained" type='button' className="dialog-Cancel-button">Close</Button>
            <Button onClick={handleImportSubmit} variant="contained" type='button' className="common-button" disabled={isImporting}>
              {isImporting ? "Importing..." : "Import"}
            </Button>
          </DialogActions>
        </Dialog>
        </>

    )
}

export default TestRegistration